var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRewards = function SvgRewards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 7.5C4.19917 7.5 4.27167 7.52199 4.33334 7.5632C4.39501 7.6044 4.44307 7.66297 4.47145 7.73149C4.49984 7.80002 4.50726 7.87542 4.49279 7.94816C4.47833 8.0209 4.44261 8.08772 4.39016 8.14017C4.33772 8.19261 4.2709 8.22832 4.19816 8.24279C4.12542 8.25726 4.05002 8.24984 3.98149 8.22145C3.91297 8.19307 3.8544 8.14501 3.8132 8.08334C3.77199 8.02167 3.75 7.94917 3.75 7.875C3.75 7.77554 3.78951 7.68016 3.85983 7.60984C3.93016 7.53951 4.02554 7.5 4.125 7.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 12.75C16.9492 12.75 17.0217 12.772 17.0833 12.8132C17.145 12.8544 17.1931 12.913 17.2215 12.9815C17.2498 13.05 17.2573 13.1254 17.2428 13.1982C17.2283 13.2709 17.1926 13.3377 17.1402 13.3902C17.0877 13.4426 17.0209 13.4783 16.9482 13.4928C16.8754 13.5073 16.8 13.4998 16.7315 13.4715C16.663 13.4431 16.6044 13.395 16.5632 13.3333C16.522 13.2717 16.5 13.1992 16.5 13.125C16.5 13.0255 16.5395 12.9302 16.6098 12.8598C16.6802 12.7895 16.7755 12.75 16.875 12.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 4.5H2.25C1.42157 4.5 0.75 5.17157 0.75 6V15C0.75 15.8284 1.42157 16.5 2.25 16.5H18.75C19.5784 16.5 20.25 15.8284 20.25 15V6C20.25 5.17157 19.5784 4.5 18.75 4.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5C12.1569 13.5 13.5 12.1569 13.5 10.5C13.5 8.84315 12.1569 7.5 10.5 7.5C8.84315 7.5 7.5 8.84315 7.5 10.5C7.5 12.1569 8.84315 13.5 10.5 13.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 9V18C23.25 18.3978 23.092 18.7794 22.8107 19.0607C22.5294 19.342 22.1478 19.5 21.75 19.5H5.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRewards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rewards.81784091.svg";
export { ForwardRef as ReactComponent };